import React, { useContext } from 'react'
import { ContextService } from '../../../../../../contexts/serviceGralContext'
import SelectInput from '../../../../../../elements/SelectInput'
import { options } from './options'

function FaltanteSelect() {

    const { currentService = {}, dinamicDataService, editDinamicServiceDataHandler } = useContext(ContextService)
    const valueForSelected = !!dinamicDataService?.ClosingDate ? currentService?.U_Faltante : dinamicDataService?.U_Faltante

    return (
        <SelectInput
            label="Faltante"
            name="U_Faltante"
            value={valueForSelected ?? ''}
            inputState={!!dinamicDataService?.ClosingDate}
            functEdit={e => editDinamicServiceDataHandler({ [e.target.name]: e.target.value })}
        >
            <option hidden>Elegir...</option>
            {
                options.YESORNO.map(val => <option key={'faltante' + val}
                    selected={valueForSelected == val}
                    value={val}>{val}</option>)
            }
        </SelectInput>
    )
}

export default React.memo(FaltanteSelect)